import { FC } from "react";
import "./PickerItem.css";

interface Props {
  item: string;
  isPicked: boolean;
  onItemClick: (item: string) => void;
}

export const PickerItem: FC<Props> = ({ item, onItemClick, isPicked }) => {
  const onClick = () => onItemClick(item);

  const isActiveClass = isPicked ? "picker-item--isActive" : "";

  return (
    <div onClick={onClick} className={`picker-item ${isActiveClass}`}>
      {item}
    </div>
  );
};
